import { render, staticRenderFns } from "./OrganizationProfileUpdate.vue?vue&type=template&id=f39dc5fa&scoped=true&"
import script from "./OrganizationProfileUpdate.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfileUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39dc5fa",
  null
  
)

export default component.exports